<div class="table-responsive">
    <table datatable id="{{tableId}}" [dtOptions]="dtOptions" class="ms-Table ms-Table--selectable order-column row-border"
    style="width:100%">
    </table>
</div>